import PropTypes from "prop-types";

export default {
  tabKey: PropTypes.string.isRequired,
};
